import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-admin-portal',
  templateUrl: './admin-portal.component.html',
  styleUrls: ['./admin-portal.component.scss'],
  standalone: false,
})
export class AdminPortalComponent {
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  sidebarOpen: boolean = true;
}
